import { FormTextField } from "@pharmupp/p3-front-commons"
import { useWatch } from "react-hook-form"
import type { FormValues } from "../../../../UserForm.component"
import { fields } from "../../GeneralInfos.fields"
import { isFunctionRequired } from "../../GeneralInfos.rg"
import { useGetUserTypeField } from "../useGetUserTypeField"

export const ConditionalFunctionField = () => {
  const type = useGetUserTypeField()
  const teamFunction = useWatch<FormValues, "teamFunction">({
    name: fields.teamFunction,
  })
  if (!isFunctionRequired(type, teamFunction)) {
    return null
  }

  return <FormTextField label="Autre fonction" name={fields.function} required />
}
